import { BuyerEdit as BuyerEditForm } from 'ui/components/buyer/patterns/BuyerEdit/BuyerEdit';

/**
 * 買い手企業編集ページ
 */
export const BuyerEdit: React.FC = () => {
    return <BuyerEditForm />;
};
